import React, { Fragment, ReactElement } from 'react';
import {
  Button,
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  DialogProps,
} from '@mui/material';

// NOTE: actionsにButton以外のコンポーネントがあってもエラーがでない
type Props = {
  actions: React.ReactElement<typeof Button>[];
  content: React.ReactNode;
  divider?: boolean;
  open: boolean;
  title?: string;
  width?: number | string;
  onClose?: () => void;
  onTransitionExited?: () => void;
} & Omit<DialogProps, 'content'>;

/**
 * 汎用的なダイアログ
 *
 * @param actions Dialog下部に表示されるButtonの配列
 * @param content Dialogのコンテンツ
 * @param divider trueの場合はコンテンツの区切り線を表示する
 * @param open Dialogの開閉状態
 * @param title Dialogのタイトル
 * @param onClose 発火条件：ダイアログの外側をクリックしたとき, escキーを押したとき、用途：escキーを押したときにダイアログを閉じる場合など
 * @param onTransitionExited 発火条件：ダイアログが閉じたとき、用途：ダイアログメッセージを初期化したい場合など
 * @param width Dialogの横幅
 * MuiのDialogのpropsも有効
 */
export function Dialog({
  actions,
  content,
  divider = false,
  open,
  title,
  width,
  onClose,
  onTransitionExited,
  ...props
}: Props): ReactElement {
  return (
    <MuiDialog
      {...props}
      open={open}
      onClose={onClose}
      onTransitionExited={onTransitionExited}
      maxWidth="lg"
      PaperProps={{ sx: { width } }}
    >
      {title && (
        <DialogTitle
          sx={{
            wordBreak: 'break-all',
          }}
        >
          {title}
        </DialogTitle>
      )}
      {divider && <Divider sx={{ mx: 3 }} />}
      <DialogContent
        sx={{
          textAlign: 'center',
          whiteSpace: 'pre-line',
          wordBreak: 'break-all',
        }}
      >
        {content}
      </DialogContent>
      {divider && <Divider sx={{ mx: 3 }} />}
      <DialogActions>
        {actions.map((button) => (
          <Fragment key={button.key}>{button}</Fragment>
        ))}
      </DialogActions>
    </MuiDialog>
  );
}
